<template>
<div class="address-autocomplete">

            <!--<h4 class="pt-2 m-0">{{job.address}}</h4>-->
            <input id="site" type="text" :class="'form-control ' + classes " name="site" required  v-model="address"
             />
            <ul v-if="searchResults && searchResults.length > 0 && !valueSet" class="dropdown-menu dropdown-menu-left shadow animated--grow-in show">
                <li class="dropdown-item" v-for="(result, i) in searchResults" :key="i" @click="selectAddress(result)">
                    {{ result }}
                </li>
            </ul>


</div>
</template>

<script>
export default {
    name: "AddressAutocomplete",
    props: {
        classes: null,
        type:String
    },
    sync:['address'],
    data() {
        return {
            searchResults: [],
            valueSet: false,
            service: null, // will reveal this later 🕵️
        };
    },
    metaInfo() {
        return {
            script: [{
                src: `https://maps.googleapis.com/maps/api/js?key=AIzaSyAM6TDORG8aqI661WGBsrgVxM_zO30pizQ&libraries=places&region=nz`,
                async: true,
                defer: true,
                callback: () => this.MapsInit() // will declare it in methods
            }]
        }
    },
    methods: {
        MapsInit() {
            this.service = new window.google.maps.places.AutocompleteService()
        },
        displaySuggestions(predictions, status) {
            if (status !== window.google.maps.places.PlacesServiceStatus.OK) {
                this.searchResults = []
                return
            }
            this.searchResults = predictions.map(prediction => prediction.description)
        },
        selectAddress(result) {
            const t = this;
            t.valueSet = true;
            t.address = result;
        },
    },
    watch: {
        address(newValue) {
            const t = this;
            if (newValue && newValue.length > 1 && !t.valueSet) {
                this.service.getPlacePredictions({
                    componentRestrictions: {
                        country: "NZ"
                    },
                    input: this.address,
                    types: ['address']
                }, this.displaySuggestions)
            }else{
                t.searchResults= [];
                t.valueSet = false;
            }
        },
    },
    mounted() {
        //document.addEventListener("click", this.close);
    },
    beforeDestroy() {
        //document.removeEventListener("click", this.close);
    },
};
</script>
<style>
.address-autocomplete .dropdown-item {
    cursor:pointer;
    font-size:1.05rem;
}
.address-autocomplete .dropdown-menu {
    margin-left: 0.75rem;
    margin-top:1px;
}
td .address-autocomplete .dropdown-menu {
    margin-left:.25rem;
    margin-top:-2px;
}
</style>

